import React, { useState } from 'react';
import css from './SelectCountryPopup.module.css';
import i18n from 'i18next';
import FormSelect from '../FormSelect';
import MaterialSelect from '../../MaterialSelect';
import FormSelectCountryNoBorder from './FormSelectCountryNoBorder';
import { OptionCountries, OptionPhones } from './constant';
import { StylesConfig } from 'react-select/dist/declarations/src/styles';
import { SearchHelper } from './search.helper';
import Select from 'react-select';
import { useCreatePortalInBody } from '../../../hooks/useCreatePortalInBody';
import { WebUtils } from '../../../utils/web';

const H = WebUtils.getBrowserHeight();

const SelectPopUpStyles: StylesConfig = {
  container: (provided) => ({
    ...provided,
    width: '100%',
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: 10,
    height: 50,
  }),
  menu: (provided, state) => ({
    ...provided,
    marginTop: 0,
    overflow: 'hidden',
    //maxHeight: H * 0.4,
  }),
  menuList: (provided, state) => ({
    ...provided,
    maxHeight: H * 0.4,
  }),
};

const SelectCountryPopup = ({ className, showCallingCode = true, border = false, ...rest }: any) => {
  const [showMenu, setShowMenu] = useState(false);
  const createBodyPortal = useCreatePortalInBody();

  return (
    <>
      {border ? (
        <FormSelect
          {...rest}
          className={css.staticSelect}
          onChange={undefined}
          options={showCallingCode ? OptionPhones : OptionCountries}
          onFocus={() => {
            setShowMenu(true);
          }}
        />
      ) : (
        <FormSelectCountryNoBorder
          {...rest}
          onChange={undefined}
          onFocus={() => {
            setShowMenu(true);
          }}
        />
      )}
      {createBodyPortal(
        showMenu ? (
          <div
            onClick={() => {
              setShowMenu(false);
            }}
            style={{
              height: H,
            }}
            className={css.modal}
          >
            <div
              onClick={(e) => {
                e.stopPropagation?.();
                // @ts-ignore
                e.stopImmediatePropagation?.();
              }}
              className={css.select}
            >
              <Select
                {...rest}
                tabIndex={-1}
                onChange={(v) => {
                  setShowMenu(false);
                  // @ts-ignore
                  rest.onChange(v.value);
                }}
                autoFocus
                showSearch
                options={showCallingCode ? OptionPhones : OptionCountries}
                filterOption={SearchHelper.filterOption}
                styles={SelectPopUpStyles}
              />
            </div>
          </div>
        ) : null,
      )}
    </>
  );
};

export default SelectCountryPopup;
